import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import(/* webpackChunkName: "home" */ '@/views/HomePage.vue'),
    meta: {
      auth: 'private'
    }
  },
  {
    path: '/connect',
    name: 'Connect',
    component: () => import(/* webpackChunkName: "connect" */ '@/views/Connect.vue'),
    meta: {
      auth: 'private'
    }
  },
  {
    path: '/permissionPage',
    name: 'PermissionPage',
    component: () => import(/* webpackChunkName: "perm" */ '@/views/PermissionPage.vue'),
    meta: {
      auth: 'private'
    }
  },
  {
    path: '/linguistConnect',
    name: 'LinguistConnect',
    component: () => import(/* webpackChunkName: "linguistConnect" */ '@/views/LinguistConnect.vue'),
    meta: {
      auth: 'private'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
    meta: {
      auth: 'public'
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    async beforeEnter(from, to, next) {
      await store.dispatch('auth/logout');
      next('/login')
    },
    meta: {
      auth: 'public'
    }
  },
  {
    path: "/:catchAll(.*)",
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound.vue'),
    meta: {
      auth: 'public'
    }
  },
  {
    path: '/maintenanceScreen',
    name: 'MaintenanceScreen',
    component: () => import(/* webpackChunkName: "connect" */ '@/views/MaintenanceScreen.vue'),
    meta: {
      auth: 'private'
    }
  }
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes
})

// global auth checking, routes can specify an auth check function, which receives a user
// if the authenticated user is set, it gets passed to that function
router.beforeEach((to, from, next) => {
  let isAuthenticated = store.state.auth.authenticated;
  if (to.meta.auth == "private") {
    if (!isAuthenticated) {
      next("/login")
    } else {
      next();
    }
  } else {
    if (isAuthenticated && to.name == "Login") {
      next("/")
    } else {
      next();
    }

  }
})


export default router
